import { Component, OnInit } from '@angular/core';
import { parentConstants } from '../../sm/parent.contants';
import { ContainerComponent } from '../../../core/component/Container.Component';

@Component({
  selector: 'app-parentformconatiner',
  templateUrl: './parentformconatiner.component.html',
  styleUrls: ['./parentformconatiner.component.css']
})
export class ParentformconatinerComponent extends ContainerComponent {
  menus: any[];
  menulist: any;
  activityobj: any;
  selecteditem: any;

  async ngOnInit() {
    await this.getmenus();
    this.activityobj = JSON.parse(this.localStorage.get("blkactivity"));
  }
  async getmenus() {

    this.menus = parentConstants.menu;
    // let userrole = JSON.parse(this.localStorage.get("userrole"));
    // let mobilemenu = userrole.utroledtl
    // this.menulist = mobilemenu.filter(o => o.controllerId === "mobilemenu");

  }

  async getscreen(event) {
    this.selecteditem = event;
    if (this.activityobj) {
      let blockactivitylist = this.activityobj.filter(o => o.activityid.toLowerCase() === event.menuKey.toLowerCase())[0];

      if (blockactivitylist) {
        this.showErrors("You do not have the right to access this information. Kindly contact your school's administrator");
      }
      else {
        this.navigate(event.route);
      }
    }
    else {
      this.navigate(event.route);
    }
  }

  async homescreen()
  {
    this.navigate("main");
  }
}



// WEBPACK FOOTER //
// ./src/app/shell/Parent-Portal/parentformconatiner/parentformconatiner.component.ts